import React, { useState } from "react";
import {
  Divider,
  Button,
  Grid,
  LinearProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Badge,
  CircularProgress,
  Paper,
  Box,
  TextField,
} from "@material-ui/core";
// import { TextField } from "formik-material-ui";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import RichTextEditor from "react-rte";
import { useFetchContext } from "../../../common/FetchContext";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { processErrorOnMutation } from "../../../../util/errorMessaging";
import { useReportApproverNote, useReportCheckListComments, useReportCheckListNotes, useReportCheckListSubmitNote } from "../../../common/CommonMutations";
import DescriptionIcon from "@material-ui/icons/Description";
import CommentIcon from '@material-ui/icons/Comment';
import { formatDate } from "../../../common/formatDate";
import { useCheckListComments } from "../../../common/CommonQueries";

export const CheckListNotes = ({

  id,
  check_list_id,
  check_list_report_id,
  count,
  Writer
}: any) => {
  const { authAxios } = useFetchContext();
  const [open, setOpen] = useState(false);
  const [showCommentEditor, setShowCommentEditor] = useState(false);
  const [showNoteEditor, setShowNoteEditor] = useState(false);
  const [subject, setSubject] = useState("");
  const [text, setText] = useState(RichTextEditor.createEmptyValue());
  const [commentText, setCommentText] = useState(RichTextEditor.createEmptyValue());
  const [errors, setErrors] = useState({ subject: "", text: "", comment: "" });



  const { data: reportdata = [], isLoading, refetch } = useReportCheckListNotes(
    id,
    check_list_id,
    check_list_report_id,
    open
  );

  const { mutateAsync: mutateNote } = useReportCheckListSubmitNote();
  const { mutateAsync: mutate } = useReportCheckListComments();

  const noteId = reportdata.length > 0 ? reportdata[0].id : null;

  const {
    data: comments,
    isError: isErrorComments,
    isLoading: isLoadingComments,
    error: errorComments,
    refetch: refetchComments
  } = useCheckListComments(noteId);


  const handleCommentChange = (value: any) => setCommentText(value);



  const handleSubmit = async () => {

    const getEditorContent = (editorValue: any) => {
      return editorValue
        .toString("markdown")
        .replace(/(&nbsp;|\s|\r?\n|\u200B)/g, "")
        .trim();
    };

    const editorContent = getEditorContent(text);

    if (!subject.trim()) {
      setErrors((prev) => ({ ...prev, subject: "Subject is required" }));
      return;
    } else {
      setErrors((prev) => ({ ...prev, subject: "" }));
    }



    if (!editorContent.length) {
      setErrors((prev) => ({ ...prev, text: "Note cannot be empty" }));
      return;
    } else {
      setErrors((prev) => ({ ...prev, text: "" }));
    }

    try {
      await mutateNote({
        authAxios,
        subject,
        comment: text.toString("markdown"),
        report: id,
        checklist: check_list_id,
        checklist_report: check_list_report_id,
      });

      await refetch();
      toast.success("Note successfully added.");
      setSubject("");
      setText(RichTextEditor.createEmptyValue());
      setErrors({ subject: "", text: "", comment: "" });
      setShowNoteEditor(false);
    } catch (err) {
      toast.error("Note failed to be added");
      console.error(err);
    }
  };

  const handleSubmitComment = async () => {

    const getEditorContent = (editorValue: any) => {
      return editorValue
        .toString("markdown")
        .replace(/(&nbsp;|\s|\r?\n|\u200B)/g, "")
        .trim();
    };

    const editorContent = getEditorContent(commentText);

    if (!editorContent.length) {
      setErrors((prev) => ({ ...prev, comment: "Comment cannot be empty" }));
      return;
    }

    try {
      await mutate({
        authAxios,
        report: id,
        comment: commentText.toString("markdown"),
        noteid: noteId,
        checklist: check_list_id,
        checklist_report: check_list_report_id,
      });
      toast.success("Comment added!");
      setCommentText(RichTextEditor.createEmptyValue());
      setErrors((prev) => ({ ...prev, comment: "" }));
      setShowCommentEditor(false);
      refetchComments();
    } catch (err) {
      toast.error("Failed to add comment");
      processErrorOnMutation(err);
    }
  };






  if (isLoadingComments || isLoading) {
    return <CircularProgress />
  }

  const handleToggleDialog = () => {
    if (open) {
      setSubject("");
      setText(RichTextEditor.createEmptyValue());
      setCommentText(RichTextEditor.createEmptyValue());
      setShowNoteEditor(false);
      setShowCommentEditor(false);
    }
    setOpen(!open);
  };


  return (
    <div>
      <Button color="primary" onClick={handleToggleDialog} fullWidth>
        <Badge badgeContent={count}>
          <DescriptionIcon />
        </Badge>
      </Button>

      {Writer ? (
        <Dialog open={open} onClose={handleToggleDialog} fullWidth maxWidth="lg">
          <DialogTitle>Attached Notes</DialogTitle>
          <DialogContent>
            <Divider style={{ marginBottom: 16 }} />
            {isLoading || isLoadingComments ? (
              <Grid container justifyContent="center" style={{ padding: 40 }}>
                <CircularProgress />
              </Grid>
            ) : (
              reportdata?.map((note: any) => (
                <React.Fragment key={note.id}>
                  <Grid
                    container
                    spacing={2}
                    style={{
                      border: "1px solid #B0B0B0",
                      borderRadius: 8,
                      padding: 12,
                      marginBottom: 12,
                    }}
                  >
                    <Grid item xs={6}>
                      <Typography variant="subtitle1" gutterBottom>
                        Subject: {note.subject}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="subtitle1" gutterBottom>
                        User: {note.username}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="subtitle1" gutterBottom>
                        Date: {formatDate(note.datetime)}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">Note: {note.comment}</Typography>
                    </Grid>
                  </Grid>



                </React.Fragment>
              ))
            )}
            {comments?.map((comment: any) => (
              <Grid item xs={12} key={comment.id}>
                <CommentIcon fontSize="small" style={{ marginRight: "10px" }} />
                <Typography variant="body1" display="inline">
                  <i>{`${comment.comment} by ${comment.username} at ${formatDate(comment.datetime)}`}</i>
                </Typography>
              </Grid>



            ))}


            {showNoteEditor && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Note Subject"
                    placeholder="Add a Subject"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    fullWidth
                    variant="outlined"
                    error={!!errors.subject}
                    helperText={errors.subject}
                  />
                </Grid>
                <Grid item xs={12}>
                  <RichTextEditor value={text} onChange={setText} />
                  {errors.text && (
                    <Typography color="error" variant="body2" style={{ marginTop: 4 }}>
                      {errors.text}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={12} >
                  <Button variant="outlined" color="secondary" onClick={() => {
                    setShowNoteEditor(false);
                    setSubject("");
                    setText(RichTextEditor.createEmptyValue());
                    setErrors({ subject: "", text: "", comment: "" });
                  }}>
                    Clear
                  </Button>

                </Grid>
              </Grid>
            )}

            {showCommentEditor && (
              <Grid item xs={12} style={{ display: "flex" }}>
                <Grid item xs={10}>
                  <RichTextEditor value={commentText} onChange={handleCommentChange} />
                  {errors.comment && (
                    <Typography color="error" variant="body2" style={{ marginTop: 4 }}>
                      {errors.comment}
                    </Typography>
                  )}
                </Grid>
                <Grid item xs={2}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setShowCommentEditor(false);
                      setCommentText(RichTextEditor.createEmptyValue());
                    }}
                    style={{ marginTop: 8, marginLeft: 5 }}
                  >
                    Clear
                  </Button>
                </Grid>

              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleToggleDialog} color="primary">
              Close
            </Button>
            {reportdata?.length === 0 && (

              <Button color="primary" onClick={() => setShowNoteEditor(true)} disabled={showNoteEditor}>
                Add Note
              </Button>
            )}
            {reportdata?.length > 0 && (
              <Button
                color="primary"
                onClick={() => setShowCommentEditor(true)}
                disabled={showCommentEditor}
              >
                Comment
              </Button>
            )}
            {showNoteEditor && (
              <>
                <Button

                  color="primary"
                  onClick={handleSubmit}

                >
                  Submit Note
                </Button>
              </>
            )}

            {showCommentEditor && (
              <>
                <Button
                  color="primary"
                  onClick={handleSubmitComment}
                  style={{ marginLeft: 8 }}
                >
                  Submit Comment
                </Button>

              </>
            )}
          </DialogActions>
        </Dialog>

      ) : (
        <Dialog open={open} onClose={handleToggleDialog} fullWidth maxWidth="lg">
          <DialogTitle>Attached Notes</DialogTitle>
          <DialogContent>
            <Divider style={{ marginBottom: 16 }} />
            {isLoading || isLoadingComments ? (
              <Grid container justifyContent="center" style={{ padding: 40 }}>
                <CircularProgress />
              </Grid>
            ) : (
              reportdata?.map((note: any) => (
                <React.Fragment key={note.id}>
                  <Grid
                    container
                    spacing={2}
                    style={{
                      border: "1px solid #B0B0B0",
                      borderRadius: 8,
                      padding: 12,
                      marginBottom: 12,
                    }}
                  >
                    <Grid item xs={6}>
                      <Typography variant="subtitle1" gutterBottom>
                        Subject: {note.subject}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography variant="subtitle1" gutterBottom>
                        User: {note.username}
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography variant="subtitle1" gutterBottom>
                        Date: {formatDate(note.datetime)}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body1">Note: {note.comment}</Typography>
                    </Grid>
                  </Grid>



                </React.Fragment>
              ))
            )}
            {comments?.map((comment: any) => (
              <Grid item xs={12} key={comment.id}>
                <CommentIcon fontSize="small" style={{ marginRight: "10px" }} />
                <Typography variant="body1" display="inline">
                  <i>{`${comment.comment} by ${comment.username} at ${formatDate(comment.datetime)}`}</i>
                </Typography>
              </Grid>



            ))}



          </DialogContent>
          <DialogActions>
            <Button onClick={handleToggleDialog} color="primary">
              Close
            </Button>

          </DialogActions>
        </Dialog>

      )}


    </div>
  );
};







